import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  selectedDataAccuracy: null,
  page: 0,
  rowsPerPage: 10,
  selectedRows: [],
  // modalContent: "",
  openModalType: null,
  selectedPriority: null,
  selectedCategory: null,
  lastUpdatedDate: null,
  selectedAssignee: [],
  selectedOwner: null,
  selectedAssigneeTasks: null,
  selectedBrand: null,
  sort: {
    keytoSort: "priority",
    direction: "desc",
  },
  dataAccuracyList: [],
  singleRowData: [],
  reloadKey: 0,
  isSuccess: false,
  allDimensions: [],
  dataAccruracyData: [],
  displayMode: "",
  hideDone: "hideDone",
  tasksByTaskStructureSharedUid: [],
  tasksByTaskStructureSharedUidLoader: false,
  selectedRowsData: [],
  selectedAsset: null,
  selectedStatus: null,
  selectedLastUpdatedDate: null,
  selectedColumnFilters: {} as Record<string, string[]>,
  bizLayerQuery: null,
};

const dataAccuracySlice = createSlice({
  name: "dataAccuracy",
  initialState,
  reducers: {
    setSelectedDataAccuracy: (state, action) => {
      state.selectedDataAccuracy = action.payload;
    },
    setPage: (state, action) => {
      state.page = action.payload;
    },
    setRowsPerPage: (state, action) => {
      state.rowsPerPage = action.payload;
    },
    setSelectedRows: (state, action) => {
      state.selectedRows = action.payload;
    },
    // setModalContent: (state, action) => {
    //   state.modalContent = action.payload;
    // },
    setOpenModalType: (state, action) => {
      state.openModalType = action.payload;
    },
    setSelectedPriority: (state, action) => {
      state.selectedPriority = action.payload;
    },
    setSelectedCategory: (state, action) => {
      state.selectedCategory = action.payload;
    },
    setLastUpdatedDate: (state, action) => {
      state.lastUpdatedDate = action.payload;
    },
    setSelectedAssignee: (state, action) => {
      state.selectedAssignee = action.payload;
    },
    setSelectedOwner: (state, action) => {
      state.selectedOwner = action.payload;
    },
    setSelectedBrand: (state, action) => {
      state.selectedBrand = action.payload;
    },
    setSort: (state, action) => {
      state.sort = action.payload;
    },
    setDataAccuracyList: (state, action) => {
      state.dataAccuracyList = action.payload;
    },
    setSingleRowData: (state, action) => {
      state.singleRowData = action.payload;
    },
    setReloadKey: (state, action) => {
      state.reloadKey = action.payload;
    },
    setIsSuccess: (state, action) => {
      state.isSuccess = action.payload;
    },
    setAllDimensions: (state, action) => {
      state.allDimensions = action.payload;
    },
    setDataAccruracyData: (state, action) => {
      state.dataAccruracyData = action.payload;
    },
    setDisplayMode: (state, action) => {
      state.displayMode = action.payload;
    },
    setHideDone: (state, action) => {
      state.hideDone = action.payload;
    },
    setTasksByTaskStructureSharedUid: (state, action) => {
      state.tasksByTaskStructureSharedUid = action.payload;
    },
    setTasksByTaskStructureSharedUidLoader: (state, action) => {
      state.tasksByTaskStructureSharedUidLoader = action.payload;
    },
    setSelectedRowsData: (state, action) => {
      state.selectedRowsData = action.payload;
    },
    setSelectedAsset: (state, action) => {
      state.selectedAsset = action.payload;
    },
    setSelectedStatus: (state, action) => {
      state.selectedStatus = action.payload;
    },
    setSelectedLastUpdatedDate: (state, action) => {
      state.selectedLastUpdatedDate = action.payload;
    },
    setSelectedColumnFilter: (state, action) => {
      const { field, values } = action.payload;
      state.selectedColumnFilters = {
        ...state.selectedColumnFilters,
        [field]: values,
      };
    },
    clearSelectedColumnFilters: (state) => {
      state.selectedColumnFilters = {};
    },
    setSelectedAssigneeTasks: (state, action) => {
      state.selectedAssigneeTasks = action.payload;
    },
    setBizLayerQuery: (state, action) => {
      state.bizLayerQuery = action.payload;
    },
  },
});

export const {
  setSelectedDataAccuracy,
  setPage,
  setRowsPerPage,
  setSelectedRows,
  // setModalContent,
  setOpenModalType,
  setSelectedPriority,
  setSelectedCategory,
  setLastUpdatedDate,
  setSelectedAssignee,
  setSelectedOwner,
  setSelectedBrand,
  setSort,
  setDataAccuracyList,
  setSingleRowData,
  setReloadKey,
  setIsSuccess,
  setAllDimensions,
  setDataAccruracyData,
  setDisplayMode,
  setHideDone,
  setTasksByTaskStructureSharedUid,
  setTasksByTaskStructureSharedUidLoader,
  setSelectedRowsData,
  setSelectedAsset,
  setSelectedStatus,
  setSelectedLastUpdatedDate,
  setSelectedColumnFilter,
  clearSelectedColumnFilters,
  setSelectedAssigneeTasks,
  setBizLayerQuery,
} = dataAccuracySlice.actions;

export default dataAccuracySlice.reducer;
